// Convención visual global de HitTCG:
//   • CARTAS (raw o gradeadas) → acento ROJO (#EF4444)
//   • PRODUCTOS SELLADOS       → acento MORADO (purple-500)
//
// Este helper centraliza la detección + etiqueta para que catálogo, buscador,
// carrito, ficha de carta y panel admin usen exactamente el mismo criterio.

const SEALED_TYPE_LABEL = {
  sealed_booster: "Sobre",
  sealed_booster_bundle: "Booster Bundle",
  sealed_box: "Caja",
  sealed_etb: "ETB",
  sealed_deck: "Mazo",
  sealed_collection: "Colección",
  sealed_blister: "Blíster",
  sealed_bundle: "Bundle",
  sealed_other: "Sellado",
};

/**
 * Detecta si un ítem es producto sellado.
 * Acepta indistintamente:
 *   - una carta       (con is_sealed / product_type)
 *   - una publicación (con card.is_sealed y/o variant=="sealed")
 *   - un ítem de carrito  { card, publication }
 *   - un resultado de suggest (con is_sealed / product_type planos)
 */
export function isSealed(o) {
  if (!o) return false;
  const card = o.card || o;
  const pub = o.publication || {};
  const pt = String(card?.product_type || o.product_type || "");
  return !!(
    card?.is_sealed ||
    o.is_sealed ||
    pt.startsWith("sealed_") ||
    pub.variant === "sealed" ||
    o.variant === "sealed"
  );
}

/** Texto compacto y en mayúsculas para el pill/badge de sellado. */
export function sealedLabel(o) {
  const card = o?.card || o || {};
  const pt = card.product_type || o.product_type;
  // Los tipos específicos SÍ concatenan "SELLADO" ("SOBRE SELLADO", "CAJA
  // SELLADA", "ETB SELLADO", "MAZO SELLADO"). Pero `sealed_other` y los
  // sellados sin `product_type` NO — antes producían "SELLADO SELLADO"
  // porque `SEALED_TYPE_LABEL.sealed_other = "Sellado"` y luego se concatenaba
  // " sellado" a mano. Ahora ese caso devuelve directamente "PRODUCTO SELLADO".
  const label = SEALED_TYPE_LABEL[pt];
  if (label && label.toLowerCase() !== "sellado") {
    return `${label} sellado`.toUpperCase();
  }
  return "PRODUCTO SELLADO";
}

/** Clases Tailwind del pill morado — se usan como <span className={sealedPillClass}>. */
export const sealedPillClass =
  "inline-flex items-center gap-1 bg-purple-600/95 text-white text-[10px] px-2 py-0.5 rounded font-bold border border-purple-300/40 uppercase tracking-wider whitespace-nowrap";

/** Clase de borde para tarjetas / tiles: morado cuando es sellado. */
export const sealedBorderClass = "border-purple-500/60";

export { SEALED_TYPE_LABEL };
